// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

import { CLEAR_FORM_DATA } from 'actions/clearFormData';
import { EMAIL_SAVED } from 'actions/emailSaved';
import { ENROLLMENT_SUCCESSFUL } from 'actions/enrollmentSuccessful';
import { FORM_DATA_SAVED } from 'actions/formDataSaved';
import { PROGRESS_CLEARED } from 'actions/progressCleared';
import { SET_LCM_PREFILL_DATA } from 'actions/setLCMPrefillData';
import { USER_CONNECTED } from 'actions/userConnected';

import { PROMO_CODE_QSP } from 'utils/queryParamHelpers';

// TODO: Can this be more dynamic?
export const initialState = {
  data: {
    firstName: '',
    lastName: '',
    email: '',
    email_verification_code: '',
    password: undefined,
    dateOfBirth: '',
    phone: '',
    phone_verification_code: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zipcode: '',
    ssn: undefined,
    sourceOfIncome: undefined,
    occupation: undefined,
    annualIncome: undefined,
    payType: undefined,
    originOfAwareness: undefined,
    promoCode: PROMO_CODE_QSP || '',
    ssnLastFour: '',
    ecbsv_consent: '',
    ssnConfirmation: '',
  },
  hasData: false,
  orderId: null,
};

/* eslint-disable default-case, no-param-reassign */
const formReducer = (state = initialState, action) =>
  produce(state, draft => {
    const { payload, type } = action;

    switch (type) {
      case EMAIL_SAVED:
        draft.data.email = payload.email;
        break;
      case USER_CONNECTED:
        mapPayloadToDraft(draft, payload, initialState);
        break;
      case FORM_DATA_SAVED:
        mapPayloadToDraft(draft, payload, initialState);
        break;
      case ENROLLMENT_SUCCESSFUL:
        if (payload && payload.orderId) {
          draft.orderId = payload.orderId;
        }
        break;
      case SET_LCM_PREFILL_DATA: {
        draft.data.firstName = !state.data.firstName
          ? payload.first_name
          : state.data.firstName;

        draft.data.lastName = !state.data.lastName
          ? payload.last_name
          : state.data.lastName;

        draft.data.email = !state.data.email ? payload.email : state.data.email;
        break;
      }
      case CLEAR_FORM_DATA:
      case PROGRESS_CLEARED:
        return initialState; // FYI I don't think this works rn with Immer
    }
  });

export default formReducer;

const mapPayloadToDraft = (draft, payload, initialState) => {
  // Make sure we're only storing form-specific data (for example, not nextOnboardingPage)
  Object.keys(initialState.data).forEach(field => {
    // Without the `address2`check, if the user previously
    // entered a value in address2 and then selects a dropdown
    // option that does not contain an apartment number, it would retain
    // its old value instead of clearing. Removing the check altogether breaks a few tests
    // and probably some existing functionality
    if (payload[field] || field === 'address2') {
      draft.data[field] = payload[field];

      if (!draft.hasData) draft.hasData = true;
    }
  });
};
